import React from 'react';
import styled from 'styled-components';
import { FlexColumn, FlexRow, SvgIcon } from '@make-software/cspr-design';
import CheckmarkIcon from 'assets/icons/ic-checkmark.svg';
import { AssetsAliases } from 'app/assets';

interface UnauthorisedSidebar {
  hide?: boolean;
}

const StyledSideBar = styled.div<{ hide?: boolean }>(({ theme, hide }) =>
  theme.withMedia({
    backgroundColor: theme.styleguideColors.backgroundTertiary,
    width: ['200px', '280px', '560px'],
    minHeight: '100vh',
    display: hide ? 'none' : ['none', 'block', 'block']
  })
);

const StyledLogoWrapper = styled(FlexRow)(() => ({
  padding: '40px 0 0 80px'
}));

const StyledStaticInfoWrapper = styled.div(({ theme }) =>
  theme.withMedia({
    padding: ['120px 0 0 20px', '120px 0 0 30px', '120px 0 0 80px'],
    width: ['200px', '260px', '400px']
  })
);

const StyledHeader = styled.div(({ theme }) => ({
  fontSize: '36px',
  fontWeight: '600',
  lineHeight: '56px',
  color: theme.styleguideColors.contentOnFill
}));

const StyledSubTitle = styled.div(({ theme }) => ({
  margin: '60px 0 40px 0',
  fontSize: '16px',
  fontWeight: '500',
  lineHeight: '24px',
  color: theme.styleguideColors.contentOnFill
}));

const StyledCheckmarkWrapper = styled.div(({ theme }) => ({
  fontSize: '16px',
  fontWeight: '400',
  lineHeight: '28px',
  color: theme.styleguideColors.contentOnFill
}));

const CheckmarkRow = styled(FlexRow)(() => ({
  marginBottom: '28px'
}));

export const UnauthorisedSidebar = ({ hide }: UnauthorisedSidebar) => (
  <StyledSideBar hide={hide}>
    <StyledLogoWrapper>
      <SvgIcon src={AssetsAliases.makeTrafficLogoWhite} height={40} width={248} />
    </StyledLogoWrapper>
    <StyledStaticInfoWrapper>
      <StyledHeader>Join the fairest solution for traffic exchange</StyledHeader>
      <StyledSubTitle>
        Start your user acquisition journey here, where you can easily add tasks to partner Apps or
        channels to attract new audiences
      </StyledSubTitle>
      <StyledCheckmarkWrapper>
        <CheckmarkRow gap={16} align={'center'}>
          <FlexColumn>
            <SvgIcon src={CheckmarkIcon} size={24} />
          </FlexColumn>
          <FlexColumn>Traffic exchange deals</FlexColumn>
        </CheckmarkRow>
        <CheckmarkRow gap={16} align={'center'}>
          <FlexColumn>
            <SvgIcon src={CheckmarkIcon} size={24} />
          </FlexColumn>
          <FlexColumn>No markups or commissions</FlexColumn>
        </CheckmarkRow>
        <CheckmarkRow gap={16} align={'center'}>
          <FlexColumn>
            <SvgIcon src={CheckmarkIcon} size={24} />
          </FlexColumn>
          <FlexColumn>Transparent flow, easy to integrate</FlexColumn>
        </CheckmarkRow>
        <CheckmarkRow gap={16}>
          <FlexColumn>
            <SvgIcon src={CheckmarkIcon} size={24} />
          </FlexColumn>
          <FlexColumn>Real-time statistics</FlexColumn>
        </CheckmarkRow>
      </StyledCheckmarkWrapper>
    </StyledStaticInfoWrapper>
  </StyledSideBar>
);
